/* eslint camelcase: 0 */
import { get, post, patch, remove } from "lib/request";
import { error } from "actions/notifications";
import resources from "constants/resources";
import { makeAuthHeader } from "utils/auth";
import _ from "underscore";
import { capitalize } from "utils/string";

const notifyError = error.bind(null, "api_error");

export const apiError = error => ({
  type: "API_ERROR",
  error
});

export const receiveCollectionError = (resource, error) => ({
  type: "RESOURCE_COLLECTION_ERROR",
  resource,
  error
});

export const receiveDetailError = (resource, error) => ({
  type: "RESOURCE_DETAIL_ERROR",
  resource,
  error
});

export const receiveCollection = (resource, payload) => ({
  type: "RECEIVE_RESOURCE_COLLECTION",
  resource,
  payload
});

export const receiveDetail = (resource, payload) => ({
  type: "RECEIVE_RESOURCE_DETAIL",
  resource,
  payload
});

export const requestCollection = resource => ({
  type: "REQUEST_RESOURCE_COLLECTION",
  resource
});

export const requestResourceCreate = resource => ({
  type: "REQUEST_RESOURCE_CREATE",
  resource
});

export const requestResourceUpdate = resource => ({
  type: "REQUEST_RESOURCE_UPDATE",
  resource
});

export const requestDetail = resource => ({
  type: "REQUEST_RESOURCE_DETAIL",
  resource
});

export const resourceDeleted = (resource, id) => ({
  type: "REQUEST_RESOURCE_DELETED",
  id,
  resource
});

export const clearCollection = resource => ({
  type: "CLEAR_RESOURCE_COLLECTION",
  resource: resource
});

export const clearDetail = resource => ({
  type: "CLEAR_RESOURCE_DETAIL",
  resource: resource
});


export const addAuthHeader = headers => {
  let authHeader = makeAuthHeader();
  return Object.assign({}, headers, authHeader);
};

export const _delete = (requestAction, receiveAction) => {
  return (resourceType, url, params) => {
    return (dispatch, getState) => {
      let headers = addAuthHeader({}, getState);

      console.log("delete", resourceType, url, params);

      dispatch(requestAction(resourceType));

      return remove(url, params, headers)
        .catch(errResponse => {
          dispatch(apiError(errResponse));
          throw new Error(errResponse.data.error);
        })
        .then(response => dispatch(receiveAction(resourceType, response.data)));
    };

  };
};

export const _fetch = (requestAction, receiveAction, errorAction) => {
  return (resourceType, url, params) => {
    return (dispatch, getState) => {
      let headers = addAuthHeader({}, getState);
      dispatch(requestAction(resourceType));
      return get(url, params, headers)
        .catch(errResponse => {
          dispatch(errorAction(resourceType, errResponse.data));
          throw new Error(errResponse.data.error);
        })
        .then(response => dispatch(receiveAction(resourceType, response.data)));
    };
  };
};

export const _post = (requestAction, receiveAction) => {
  //console.log("_post", requestAction, receiveAction);
  return (resourceType, url, params) => {
    return (dispatch, getState) => {
      dispatch(requestAction(resourceType));
      const headers = addAuthHeader({}, getState);
      return post(url, params, headers)
        .catch(errResponse => {
          let errors = [];
          _.map(errResponse.data, (val, key) =>
            errors.push(`${key} ${val[0]}`)
          );
          dispatch(apiError(errResponse.data));
          dispatch(notifyError(errors.join(", ")));
          throw new Error(errResponse.data.error);
        })
        .then(response => {
          // console.log("response", response);
          dispatch(receiveAction(resourceType, response.data));
          return response.data;
        });
    };
  };
};


export const _patch = (requestAction, receiveAction) => {
  return (resourceType, url, params) => {
    return (dispatch, getState) => {
      dispatch(requestAction(resourceType));
      const headers = addAuthHeader({}, getState);
      return patch(url, params, headers)
        .catch(errResponse => {
          dispatch(apiError(errResponse.response.data));
          if (errResponse.response.data.error) {
            dispatch(notifyError(errResponse.response.data.error));
          } else {
            dispatch(notifyError(_.values(errResponse.response.data)[0][0]));
          }
          throw new Error(errResponse.response.data.error);
        })
        .then(response => dispatch(receiveAction(resourceType, response.data)));
    };
  };
};

export const fetchCollection = _fetch(
  requestCollection,
  receiveCollection,
  receiveCollectionError
);
export const fetchDetail = _fetch(
  requestDetail,
  receiveDetail,
  receiveDetailError
);

export const postDetail = _post(requestResourceCreate, receiveDetail);

export const patchDetail = _patch(requestResourceUpdate, receiveDetail);

export const deleteDetail = _delete(resourceDeleted, clearDetail);

export const actions = {};

Object.keys(resources).forEach(key => {
  let resource = resources[key];
  actions["fetch" + capitalize(key)] = (id, params) => {
    return fetchDetail(key, `${resource.url}/${id}`, params);
  };
  actions["fetch" + capitalize(resource.plural)] = (params = {}, id = null) => {
    let url = resource.url;
    if (id) {
      url = url + `/${id}`;
    }
    return fetchCollection(key, url, params);
  };
  actions["create" + capitalize(key)] = params => {
    return postDetail(key, resource.url, params);
  };
  actions["patch" + capitalize(key)] = (id, params) => {
    return patchDetail(key, `${resource.url}/${id}`, params);
  };
  actions["delete" + capitalize(key)] = (id, params) => {
    return deleteDetail(key, `${resource.url}/${id}`, params);
  };

});



// WEBPACK FOOTER //
// ./src/actions/resources.js